import React from 'react';
import '../styles/industries.css'
import AnimationBox from '../animationBox';
import AnimatedArrowButton from './AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AnimatedCard from './AnimatedCard';


const Industries = () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };
    const cards = [
        { title: '01', heading: "Manufacturing" , content:"Streamline production lines with advanced robotic systems designed for precision, reliability, and scalability" },
        { title: '02', heading: "Health Care" , content:"Improve patient care and operational efficiency with robots tailored for medical and support tasks." },
        { title: '03', heading: "Logistics" , content:"Optimize material handling and inventory management with robotics solutions for seamless operations" },
        { title: '04', heading: "Retail" , content:"Enhance customer experience and back-end operations with automation in inventory, shelving, and checkout." },
        { title: '05', heading: "Hospital" , content:"Deliver exceptional guest experiences with service robots for room service, cleaning, and concierge tasks." },
        
      ];

    return(<div className='industries'>

        <AnimationBox>
            <div className='industries-inner' >
            <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        
                        <h4 style={{color:'#FFD52B'}}>Industries We Serve </h4>
                        
            </div>
            <div style={{padding:'20px'}}>

                        
                        <div className='' style={{textAlign:'left'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between'}}><h1 style={{fontWeight:"600"}}>Empowering Industries Through<br></br> Intelligent Automation</h1> <div className='button1'> <AnimatedArrowButton  text="Learn More" link="/Robotics-Usecase"   /></div> </div>

                            <div className='button2'> <AnimatedArrowButton  text="Learn More" link="/Robotics-Usecase"   /></div> 
                        </div>
            </div>

            <div style={{ padding: "20px", maxWidth: "1000px", margin: "auto" }}>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            {/* <div
              style={{
                height: "300px",
                backgroundColor: "#ddd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px"
              }}
            >
              {card.content}
            </div> */}
            <AnimatedCard title={card.title}  content={card.content} heading={card.heading} />
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        </AnimationBox>
    

    </div>);

}

export default Industries;